import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useGetTutorQuery } from "../../../../store/services/student/TutorService";
import { TutorAvailabilitySection } from "./TutorAvailabilitySection";
import { TutorProfileHeader } from "./TutorProfileHeader";
import { TutorReviewsSection } from "./TutorReviewsSection";
import { trackMetaEvent } from "../../../utils/metaPixel";
import { pushDataLayerEvent } from "../../../utils/gtm";

export const TutorProfile = () => {
    const { id } = useParams();

    const { data, isLoading, error } = useGetTutorQuery({ Id: id });

    // Track Availability Calendar Opened -> Lead when availability data is present
    useEffect(() => {

        if (isLoading || error || !data?.succeeded) return;

        const tutor = data.data;
        const metaEventId = data?.data?.metaEventId;
        const googleEventId = data?.data?.googleEventId;
        const hasAvailability = Array.isArray(tutor?.tutorAvailability) && tutor.tutorAvailability.length > 0;

        if (metaEventId) {
            trackMetaEvent(
                "Lead",
                {
                    content_name: "Tutor Availability",
                    tutor_id: tutor.id,
                },
                metaEventId
            );
        }

        if (hasAvailability) {
            pushDataLayerEvent("tutor_availability_view", {
                google_event_id: googleEventId,
                tutor_id: tutor.id,
            });
        }
    }, [data, isLoading, error]);

    if (isLoading) return <p>Loading...</p>;
    if (error || !data?.succeeded) return <p>Failed to load tutor data</p>;

    const tutor = data.data;

    // Convert availability structure
    const parsedAvailability = tutor?.tutorAvailability?.map((day) => ({
        day: day.day,
        slots: day.slots?.map(
            (slot) => `${slot.startTime} - ${slot.endTime}`
        )
    }));

    return (
        <div className="container py-4">
            <div className="row mb-4">
                <div className="col-12">
                    <TutorProfileHeader tutor={tutor} />
                </div>
            </div>

            <div className="row">
                <div className="col-lg-6 col-md-12">
                    <TutorReviewsSection reviews={tutor.sampleReviews} />
                </div>
                <div className="col-lg-6 col-md-12">
                    <TutorAvailabilitySection availability={parsedAvailability} />
                </div>
            </div>
        </div>
    );
};